export default {
  map_unavailable: 'Impossibile caricare la mappa. Ricarica la pagina e riprova.',
  stubs: {
    name: 'Zona di consegna {{number}}',
  },
  buttons: {
    add_new_zone: 'Aggiungi nuova zona',
  },
  toasts: {
    failed_to_load_data: 'Caricamento zone di consegna non riuscito',
  },
};
